import { Box } from '@chakra-ui/react'
import React, { RefObject, useRef } from 'react'

import { useTranslations } from '~shared-components/hooks/useTranslations'

import { AnimatedList } from '..'
import { StackWrapper } from '../Animation/AnimatedList'
import { FullScreenLoaderRound } from '../Loader/LoaderRound'
import { NoResults } from '../NoResults/NoResults'
import { Pagination } from '../Pagination/Pagination'

interface PaginatedListProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  analyticsProps?: { [key: string]: any }
  currentPage: number | undefined
  hasNextPage: boolean
  loadingItems: boolean | undefined
  noResultsMessage?: string
  onChangePage: (page: number) => void
  topRef?: RefObject<HTMLElement>
  totalPages: number
  useStack?: boolean
}

export const PaginatedList: React.FC<PaginatedListProps> = ({
  analyticsProps,
  children,
  currentPage,
  hasNextPage,
  loadingItems,
  noResultsMessage,
  onChangePage,
  topRef,
  totalPages,
  useStack = true,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const t = useTranslations()

  return (
    <Box ref={ref} position="relative">
      <FullScreenLoaderRound loading={loadingItems} />
      <AnimatedList wrapper={useStack ? StackWrapper : undefined}>
        {React.Children.count(children) > 0
          ? children
          : !loadingItems && (
              <NoResults>
                {noResultsMessage || t('message.noitemstoshow')}
              </NoResults>
            )}
      </AnimatedList>
      {(totalPages > 1 || hasNextPage) && (
        <Pagination
          analyticsProps={analyticsProps}
          currentPage={currentPage ? currentPage : 1}
          onGoToPage={number => {
            const top = topRef?.current
              ? window.scrollY + topRef.current.getBoundingClientRect().top
              : ref.current
              ? ref.current.offsetTop
              : undefined
            if (top) {
              window?.scrollTo({ behavior: 'smooth', top })
            }
            onChangePage(number)
          }}
          totalPages={totalPages}
        />
      )}
    </Box>
  )
}
